// extracted by mini-css-extract-plugin
module.exports = {"lead-text":"LeadText_lead-text__K79M1"};